import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { noop } from 'lodash';
import { breakpoint } from '@zocdoc/components/src/grid';
import { blue } from '@zocdoc/branding/colors';
import { TextMeTheApp } from '@zocdoc/components/src/TextMeTheAppForm';
import AppPreview from './mobile-app_rb.png';
import { AppStoreRectangularBadge, GooglePlayRectangularBadge } from '@zocdoc/components/src/icons';
import { Container, Headline, List, ListItem } from '../Panel';

export class GetAppPanelView extends React.PureComponent {
    static propTypes = {
        trackClickTextAppLink: PropTypes.func,
        trackClickAppStore: PropTypes.func,
        trackClickGooglePlay: PropTypes.func,
        trackClickPhoneField: PropTypes.func,
        trackTypePhoneNumber: PropTypes.func,
    };

    static defaultProps = {
        trackClickTextAppLink: noop,
        trackClickAppStore: noop,
        trackClickGooglePlay: noop,
        trackClickPhoneField: noop,
        trackTypePhoneNumber: noop,
    };

    render() {
        const {
            trackClickTextAppLink,
            trackClickAppStore,
            trackClickGooglePlay,
            trackClickPhoneField,
            trackTypePhoneNumber,
        } = this.props;

        return (
            <GetAppPanelContainer>
                <PanelContent>
                    <div>
                        <Headline>
                            <FormattedMessage
                                defaultMessage="Get the Zocdoc app."
                                id="Home.GetApp.GetTheApp"
                            />
                        </Headline>

                        <List>
                            <ListItem>
                                <FormattedMessage
                                    defaultMessage="Find nearby doctors in your network"
                                    id="Home.GetApp.FindDoctors"
                                />
                            </ListItem>
                            <ListItem>
                                <FormattedMessage
                                    defaultMessage="Browse doctor reviews by real patients"
                                    id="Home.GetApp.BrowseReviews"
                                />
                            </ListItem>
                            <ListItem>
                                <FormattedMessage
                                    defaultMessage="Book doctor appointments with a tap"
                                    id="Home.GetApp.BookAppointments"
                                />
                            </ListItem>
                        </List>
                        <TextMeTheApp
                            trackChangePhoneNumber={trackTypePhoneNumber}
                            trackClickPhoneNumber={trackClickPhoneField}
                            trackClickTextAppLink={trackClickTextAppLink}
                        />
                    </div>
                    <DownloadBadgeContainer>
                        <DownloadBadge
                            data-test="app-store-badge"
                            href="http://itunes.apple.com/us/app/zocdoc-doctor-appointments/id391062219?mt=8"
                            onClick={trackClickAppStore}
                        >
                            <AppStoreRectangularBadge />
                        </DownloadBadge>
                        <DownloadBadge
                            data-test="google-play-badge"
                            href="https://market.android.com/details?id=com.zocdoc.android"
                            onClick={trackClickGooglePlay}
                        >
                            <GooglePlayRectangularBadge />
                        </DownloadBadge>
                    </DownloadBadgeContainer>
                </PanelContent>
            </GetAppPanelContainer>
        );
    }
}

const GetAppPanelContainer = styled(Container)`
    justify-content: center;

    background-color: ${blue};
    background-repeat: no-repeat;

    ${breakpoint.small} {
        padding-top: 60px;
        padding-bottom: 500px; /* space for the background image */

        background-size: auto 450px;
        background-position: center 100%;
        background-image: url(${AppPreview});
    }
    ${breakpoint.medium} {
        justify-content: flex-end;
        align-items: center;
        padding-top: 0;
        padding-bottom: 0;

        background-size: auto;
        background-position: 10% 100%;
    }
`;

const PanelContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    ${breakpoint.medium} {
        flex-basis: 50%;
        align-items: flex-start;
    }
`;

const DownloadBadgeContainer = styled.div`
    ${breakpoint.small} {
        margin-top: 48px;
    }
    ${breakpoint.medium} {
        margin-top: 64px;
    }
`;

const DownloadBadge = styled.a`
    display: inline-block;
    font-size: 40px;

    & + & {
        margin-left: 16px;
    }
`;
